import { useEffect, useState } from 'react';

import useEnvironmentVariableData from '@usas/ui-web/state/environmentVariable/UseEnvironmentVariableData';

const useSisenseShowAllTimesDropdown = () => {
    const [showAllTimesOptions, setShowAllTimesOptions] = useState({ options: [] });
    const { environmentVariableState, SISENSE_SHOW_BEST_TIMES_ONLY_TEXT,
        SISENSE_SHOW_ALL_TIMES_TEXT } = useEnvironmentVariableData();

    useEffect(() => {
        if (environmentVariableState.isLoaded === true) {
            const formattedOptions = [{
                id: 1, name: SISENSE_SHOW_ALL_TIMES_TEXT
            },
            {
                id: 2, name: SISENSE_SHOW_BEST_TIMES_ONLY_TEXT
            }];
            setShowAllTimesOptions({ ...showAllTimesOptions, options: formattedOptions });
        }
        else {
            setShowAllTimesOptions({ ...showAllTimesOptions, options: [] });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [environmentVariableState])

    return {
        showAllTimesOptions
    };
};

export default useSisenseShowAllTimesDropdown;